import { gql } from "@apollo/client";

import { SEAT_MAP_FRAGMENT } from "./fragments";

export const GET_SEAT_MAPS = gql`
  ${SEAT_MAP_FRAGMENT}
  query GetSeatMap(
    $take: Int
    $skip: Int
    $filters: SeatMapFilterInput
    $orderBy: [SeatMapOrderByInput!]
  ) {
    seatMaps(take: $take, skip: $skip, filters: $filters, orderBy: $orderBy) {
      nodes {
        ...SeatMap
      }
    }
  }
`;
